// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`Referidos test Match con el snapshot 1`] = `""`;
